import {createRouter, createWebHistory} from 'vue-router'
import {constantRouterMap} from './routes';
import { empty, getToken, shouldRefreshCurrentAccessToken } from '@/utils/auth';
import { rememberLoginRedirect } from '@/utils/loginRedirect';
import { ensureFreshAccessToken } from '@/utils/silentAuth';

const router = createRouter({
    history: createWebHistory(),
    routes: constantRouterMap
});

/**
 * 导航守卫：未登录用户重定向到登录页
 * 白名单路由允许无 token 访问，避免死循环
 */
const whiteList = ['/', '/404', '/401'];

router.beforeEach(async (to, from, next) => {
    if (whiteList.includes(to.path)) {
        // 白名单页面（登录页、404、401）无需续登。
        next();
    } else {
        const requiresRefresh = empty(getToken()) || shouldRefreshCurrentAccessToken();
        if (requiresRefresh) {
            rememberLoginRedirect(to);
        }
        try {
            await ensureFreshAccessToken();
            next();
        } catch (error) {
            next('/');
        }
    }
});

export default router
